import moment from "moment"

interface Props {
  dateString: string
}

export function FormatDate({ dateString }: Props) {
  // Use .local() to convert from UTC to user's local timezone
  const localDate = moment.utc(dateString).local()
  return localDate.format("dddd")
}

export function FormatTime({ dateString }: Props) {
  const localDate = moment.utc(dateString).local()
  return <div>{localDate.format("D-MMMM")}</div>
}

export function FormatChangeTime({ dateString }: Props) {
  const localDate = moment.utc(dateString).local()
  return <div> {localDate.format("h:mm A")}</div>
}

export function FormatDateMonthDay({ dateString }: Props) {
  const localDate = moment.utc(dateString).local()
  return <div>{localDate.format("DD MMM, dddd")}</div>
}
